import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-form2-view-criminal-proceeding',
  templateUrl: './form2-view-criminal-proceeding.component.html',
  styleUrls: ['./form2-view-criminal-proceeding.component.css']
})
export class Form2ViewCriminalProceedingComponent implements OnInit {
  title="Form1/Form 2: Form for verification of character and antecedents of All Employees";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/staff-criminal-proceedings/form2-view-criminal-proceeding/form2-view-criminal-proceeding.component.ts